import { useMemo, useState } from "react";

import { AppointmentExchangeResponse } from "@/api";
import { useExchangeDetailQuery } from "@/pages/exchange/hooks/useExchangeDetailQuery";
import { useExchangeRequestMutations } from "@/pages/exchange/hooks/useExchangeRequestMutations";

import { partitionOffers } from "../ExchangeOffersDialog.utils";

/**
 * State of the "Angebote zur Tauschanfrage" overlay: the offers split into open and decided, the
 * requester's two immediate decisions, and whether the edit dialog is open. Neither decision asks for
 * confirmation — the story wants them to take effect on click; the refetch afterwards moves the cards
 * between the sections.
 */
export function useExchangeOffers(exchange: AppointmentExchangeResponse) {
  const { detail, isLoading, isError } = useExchangeDetailQuery(exchange.id);
  const { acceptOffer, rejectOffer, isBusy } = useExchangeRequestMutations();
  const [isEditRequestOpen, setIsEditRequestOpen] = useState(false);

  const { pending, processed } = useMemo(() => partitionOffers(detail?.offers ?? []), [detail]);

  return {
    request: detail?.request ?? exchange,
    pending,
    processed,
    isLoading,
    isError,
    isBusy,
    accept: (offerId: string) => acceptOffer.mutate({ exchangeId: exchange.id, offerId }),
    reject: (offerId: string) => rejectOffer.mutate({ exchangeId: exchange.id, offerId }),
    isEditRequestOpen,
    openEditRequest: () => setIsEditRequestOpen(true),
    closeEditRequest: () => setIsEditRequestOpen(false),
  };
}
